import type { ImageWidget } from "~/types/widgets";
import { Picture, Source } from "~/components/ui/Picture";
import { type SectionProps as SectionProps } from "~/types/deco";
/**
 * @titleBy matcher
 */
export interface Banner {
    matcher: string;
    /**
     * @title Título
     */
    title?: string;
    /**
     * @Title Subtítulo
     */
    subtitle?: string;
    /**
     * @title Imagem
     */
    image: {
        desktop: ImageWidget;
        mobile: ImageWidget;
        /**
         * @title Texto alternativo
         */
        alt?: string;
    };
}
const DEFAULT_PROPS = {
    banners: [
        {
            image: {
                mobile: 'https://decoims.com/miess-01/9073290b-a2a6-4a7c-9019-e11956369612/91102b71-4832-486a-b683-5f7b06f649af.jpg',
                desktop: 'https://decoims.com/miess-01/7a3f4869-97cf-4265-a18e-3e792fcb2432/ec597b6a-dcf1-48ca-a99d-95b3c6304f96.jpg',
                alt: 'a',
            },
            title: 'Woman',
            matcher: '/*',
            subtitle: 'As',
        },
    ],
};
function Banner(props: SectionProps<typeof loader>) {
    const { banner } = props;
    if (!banner) {
        return null;
    }
    const { title, subtitle, image } = banner;
    return (<div className='grid grid-cols-1 grid-rows-1 h-[120px] md:h-[200px]'>
            <Picture preload className='col-start-1 col-span-1 row-start-1 row-span-1'>
                <Source src={image.mobile} width={360} height={120} media='(max-width: 767px)'/>
                <Source src={image.desktop} width={1440} height={200} media='(min-width: 767px)'/>
                <img className='w-full h-full object-cover' src={image.desktop} alt={image.alt ?? title} loading='eager' fetchPriority='high' width={1440} height={200}/>
            </Picture>

            <div className='container flex flex-col items-center justify-center sm:items-start col-start-1 col-span-1 row-start-1 row-span-1 w-full'>
                <h1>
                    <span className='text-5xl font-medium text-base-100'>{title}</span>
                </h1>
                <h2>
                    <span className='text-xl font-medium text-base-100'>{subtitle}</span>
                </h2>
            </div>
        </div>);
}
export interface Props {
    banners?: Banner[];
}
export const loader = (props: Props & { __pageUrl?: string }) => {
    const { banners } = { ...DEFAULT_PROPS, ...props };
    const pathname = (() => {
        try { return new URL(props.__pageUrl ?? "/", "https://x").pathname; }
        catch { return "/"; }
    })();
    const banner = banners.find(({ matcher }) => new URLPattern({ pathname: matcher }).test({ pathname }));
    return { banner };
};
export default Banner;
